/**
 * Human-readable labels for the target-model method keys, shared by the
 * sentinel builder, list, and detail views.
 *
 * A fitted `/score` or run response carries its own per-method `label` (usually
 * the richest description), so callers should prefer that and fall back to this
 * static map — that is exactly what {@link methodLabel} does. Kept here rather
 * than duplicated per component so the four method names read the same
 * everywhere. (The internal Experiment Lab has its own terser labels in
 * `experiment/knobCopy.ts`; those are deliberately left untouched.)
 */
import type { I18n, MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'

export const METHOD_LABELS: Record<string, MessageDescriptor> = {
  target_mlp_none: msg`MLP (no drivers)`,
  target_mlp_driver: msg`MLP + drivers`,
  target_mlp_driver_own: msg`MLP + drivers + own history`,
  target_knn: msg`kNN`,
}

/**
 * The label to show for a method key: the response's own label when it has one,
 * else the static map, else the raw key (never blank).
 */
export const methodLabel = (
  i18n: I18n,
  key: string,
  label?: string | null
): string => (label && label.trim()) || i18n._(METHOD_LABELS[key]) || key
